<template>
  <section id='playingMethod'>
    <div class="play_go" @click='randomRoom'></div>
    <div class="play_tab">
      <div class="plat_tab_click">
        <span :class="userButton? 'user_true': 'user_false'" @click='playTabClick(true)'></span>
        <span :class="!userButton? 'anchor_true': 'anchor_false'" @click='playTabClick(false)'></span>
      </div>
      <ul v-if='userButton'>
        <li>
          <span>1</span>
          <p>喵喵有两种类型：九秀喵、基础喵喵；主播只能获得九秀喵，用户只能获得基础喵喵；</p>
        </li>
        <li>
          <span>2</span>
          <p>基础喵喵有8种：福星喵、财气喵、如愿喵、锦鲤喵、团圆喵、桃花喵、欢喜喵、新年喵；</p>
        </li>
        <li>
          <span>3</span>
          <p>用户集齐8种喵喵后可以合成红包，在2月11日晚上9点19分开红包瓜分5000万九币；</p>
        </li>
        <li>
          <span>4</span>
          <p>可以通过以下方式获得基础喵喵：“喜欢主播”得喵喵、看直播得喵喵、玩“喵喵雨”得喵喵、跟朋友要喵、充值的喵喵、送“太平乐”礼物得喵喵、绑定手机号得喵喵；</p>
        </li>
        <li>
          <span>5</span>
          <p>用户只能通过跟主播讨要，或被主播赠送，才能获得九秀喵；</p>
        </li>
        <li>
          <span>6</span>
          <p>获得的九秀喵可以转化为任意基础喵喵；</p>
        </li>
        <li>
          <span>7</span>
          <p>点击各直播间“招财猫”底部的【解锁】/【助力】按钮，可向主播赠送基础喵喵，助当前主播解锁招财猫、提升“主播招财榜”排名；</p>
        </li>
      </ul>
      <ul v-if='!userButton'>
        <li>
          <span>1</span>
          <p>喵喵有两种类型：九秀喵、基础喵喵；主播只能获得九秀喵，用户只能获得基础喵喵；</p>
        </li>
        <li>
          <span>2</span>
          <p>可以通过以下方式获得九秀喵：开播达到设定时长、收礼达到设定金额、进入“主播招财榜”；</p>
        </li>
        <li>
          <span>3</span>
          <p>获得的九秀喵只能送给用户；</p>
        </li>
        <li>
          <span>4</span>
          <p>每个主播有代表自己的“招财猫”；</p>
        </li>
        <li>
          <span>5</span>
          <p>用户向主播赠送基础喵喵，可助主播解锁招财猫，招财猫解锁后，继续赠送基础喵喵可助主播提升其“主播招财榜”排名；</p>
        </li>
        <li>
          <span>6</span>
          <p>在“主播招财榜排名”越高，2月11日晚上9点09分，主播分得的“糖果”礼物越多；</p>
        </li>
        <li>
          <span>7</span>
          <p>每个糖果礼物的价格为100九币，赠送后可以获得正常分成；</p>
        </li>
      </ul>
      <img src="@/assets/images/miao/play_text_top.png" alt="" class="play_text_top">
      <!-- <img src="@/assets/images/miao/play_text_content.png" alt="" class="play_text_content"> -->
      <img src="@/assets/images/miao/play_text_bottom.png" alt="" class="play_text_bottom">
    </div>
  </section>
</template>
<script>
import { get } from '@/http/index.js'
import api from '@/http/api'
export default {
  name : "playingMethod",
  data() {
    return {
      userButton: true
    }
  },
  created() {
  },
  mounted () {
    var _hmt = _hmt || [];
    _hmt.push(['_trackEvent', 'pageLoad','onLoad','roomLoad']);
    (function() {
        var hm = document.createElement("script");
        hm.src = "//hm.baidu.com/hm.js?7bd0e3ec9b5e098783448c9f65c145de";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
    })();
    document.title = '新年集喵'
    setTimeout(() => {
      console.log(window.winOcx)
      if (window.winOcx.getUserData) {
        window.winOcx.getUserData(function(data){
          console.log(data)
          sessionStorage.setItem('initData', JSON.stringify(data))
        })
      }
    }, 1000);
  },
  methods: {
    playTabClick(bol) {
      if (bol) {
        this.userButton = true
      } else {
        this.userButton = false
      }
    },
    randomRoom() {
      get(api.getRecommendRid, '').then(res => {
        if (res.code == 200) {
          let { rid } = res.data
          window.winOcx.openPage('room',{
            'rid' :rid,
            'status' :1
          });
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  #playingMethod{
    width: 100%;
    background: url('../../assets/images/miao/play.png') #E41D22 no-repeat;
    background-size: 100% auto;
    padding: 1000px 0 200px 0;
    .play_text_top{
      position: absolute;
      top: 0;
      width: 100%;
      height: 260px;
      left: 0;
    }
    .play_text_content{
      position: absolute;
      width: 100%;
      height: 75%;
      top: 260px;
      bottom: 260px;
    }
    .play_text_bottom{
      position: absolute;
      width: 100%;
      bottom: 0;
    }
    .play_go{
      width: 368px;
      height: 90px;
      background: url('../../assets/images/miao/button@2x.png') no-repeat;
      background-size: 100% 100%;
      margin: 0 auto 0 auto;
    }
    .play_tab{
      margin: 76px 24px 0 24px;
      background-size: 100% 100%;
      padding: 140px 0 148px 0;
      box-sizing: border-box;
      position: relative;
      ul{
        position: relative;
        z-index: 1;
        background: url('../../assets/images/miao/play_text_content.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .plat_tab_click{
      display: flex;
      justify-content: center;
      position: relative;
      z-index: 1;
      span:nth-child(1){
        margin-right: 40px;
      }
      span{
        width: 200px;
        height: 74px;
      }
      .user_true{
        background: url('../../assets/images/miao/user_true.png') no-repeat;
        background-size: 100% 100%;
      }
      .user_false{
        background: url('../../assets/images/miao/user_false.png') no-repeat;
        background-size: 100% 100%;
      }
      .anchor_true {
        background: url('../../assets/images/miao/anchor_true.png') no-repeat;
        background-size: 100% 100%;
      }
      .anchor_false {
        background: url('../../assets/images/miao/anchor_false.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    ul{
      padding: 0 58px 0 52px;
      li{
        display: flex;
        margin-top: 36px;
        span{
          width: 34px;
          height: 31px;
          text-align: center;
          line-height: 34px;
          background: #994A0B;
          color: #fff;
          border-radius: 50%;
          font-size: 24px;
          padding-top: 3px;
        }
        p{
          margin-left: 16px;
          width: 542px;
          color: #994A0B;
          font-size: 26px;
        }
      }
    }
  }
  
</style>